// TODO: Refactor and merge with PrintQuote
import React from 'react'
import { capitalize } from 'lodash'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import Paper from 'material-ui-legacy/Paper'

import PageTitle from '../UI/PageTitle'
import BackButton from '../UI/BackButton'
import PrintButton from '../UI/PrintButton'
import LinearLoader from '../UI/LinearLoader'
import ErrorDialog from '../UI/ErrorDialog'

import InternalActual from './InternalActual'
import ClientFacingActual from './ClientFacingActual'

import errors from '../../lib/errors.js'
import Resource from '../../stores/resource'
const ActualStore = Resource('actuals')
const ProjectStore = Resource('projects')

/*
This is designed to be a stand-alone page (more or less),
so props can be received via props.match.
See Projects component for more details.

- actualId, projectId: Number, self-explanatory
*/
class PrintActual extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      actualId: this.props.actualId || this.props.match.params.actualId,
      projectId: this.props.projectId || this.props.match.params.projectId,
      actual: {},
      project: {},
      loading: true,
      error: ''
    }

    // We'll change the window title to make sure the printed PDF
    // has a decent title.
    this.originalWindowTitle = window.document.title
  }

  componentWillMount() {
    const promises = [
      ActualStore.find(this.state.actualId),
      ProjectStore.findBy({ id: this.state.projectId }, [
        'agency',
        'client',
        'agencyProducer',
        'user'
      ])
    ]
    Promise.all(promises)
      .then(results =>
        this.setState({
          actual: results[0].data,
          project: results[1].data,
          loading: false
        })
      )
      .catch(error =>
        this.setState({ error: errors.unpack(error), loading: false })
      )
  }

  _resetWindowTitle = () => (window.document.title = this.originalWindowTitle)

  _print = () => {
    // We need to change the window title so the PDF file is named right
    const projectName = this.state.project.attributes.name
    const actualName = this.state.actual.attributes.name
    const actualType = this.props.match.params.actualType || 'internal'
    window.document.title = `${actualType.toUpperCase()} ACTUAL - ${projectName} - ${actualName}`

    // Now we print and revert (out of order because async)
    if ('onafterprint' in window) {
      window.onafterprint = this._resetWindowTitle
    } else {
      setTimeout(this._resetWindowTitle, 2000)
    }
    window.print()
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  render() {
    const { actual, project, error, loading } = this.state

    // Figure out what kind of actual to print
    const actualType = this.props.match.params.actualType || 'internal'
    const ActualDisplayComponent =
      actualType === 'internal' ? InternalActual : ClientFacingActual

    if (loading) return <LinearLoader />

    if (error)
      return (
        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      )

    const paperStyle = {
      padding: '40px'
    }

    return (
      <section>
        <Row style={{ marginBottom: '40px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <header>
              <PageTitle className="truncate-text">
                {capitalize(actualType)} actuals
              </PageTitle>
            </header>
            <PrintButton
              label="Print / Save PDF"
              onTouchTap={() => this._print()}
            />
          </div>
        </Row>
        <hr />

        <Row>
          <Col lg="10" lg-offset="1" md="12">
            <Paper style={paperStyle}>
              <div className="printable">
                <ActualDisplayComponent
                  actual={actual}
                  project={project}
                  print
                />
              </div>
            </Paper>
          </Col>
        </Row>
        <hr />

        <BackButton />
      </section>
    )
  }
}

export default PrintActual



// WEBPACK FOOTER //
// ./src/components/Quotes/PrintActual.jsx